import React from "react";
import "./articles.css";

const AssociationMembers = () => {
  return (
    <div className="main">
      <div className="art-container">
        <div className="about-header">
          <h1>GCU Alumni Association Executive Members</h1>
        </div>
        <div className="association-members-container">
          <div className="member-table">
            <table>
              <thead>
                <tr>
                  <th>Sl.</th>
                  <th>Name</th>
                  <th>Occupation & Designation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Dr. Dipankar Saha</td>
                  <td>Registrar, Girijananda Choudhury University, Assam.<br />President</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Mr. Abhinandan Kalita</td>
                  <td>Assistant Professor, Department of ECE, Girijananda Choudhury University, Assam<br />Working-President</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Ms. Shrabani Medhi</td>
                  <td>Assistant Professor, Department of CSE, Girijananda Choudhury University, Assam<br />Vice-President</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Mr. Mazhrul Chowdhury</td>
                  <td>Pharmacist, Kamalpur Block PHC, Kamrup (R)<br />Vice-President</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Mr. Bishwadeep Poddar</td>
                  <td>Deputy Manager, Industrial Revenue Collection Area -II, APDCL, Jalukbari<br />Vice-President</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Mr. Faruk Ahmed</td>
                  <td>Assistant Professor, Department of BA, Girijananda Choudhury University, Assam<br />Secretary</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>Mr. Trideep Saikia</td>
                  <td>Assistant Professor, School of Pharmaceutical Sciences, Girijananda Choudhury University, Assam<br />Treasurer</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Ms. Subhadra Das</td>
                  <td>Assistant Professor, Department of ECE, Girijananda Choudhury University, Assam<br />Joint Secretary</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>Mr. Amlanjyoti Dutta</td>
                  <td>Sr. Accounts Assistant<br />NFR HQ (Construction), Maligaon, Indian Railways<br />Joint Secretary</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Ms. Ritisha Das</td>
                  <td>Associate, The Federal Bank Ltd., Bongaigaon Branch<br />Joint Secretary</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>Dr. Junumoni Das</td>
                  <td>Assistant Professor, Department of BA, Girijananda Choudhury University, Assam<br />Member</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Ms. Ritushree Dutta</td>
                  <td>Assistant Professor, Department of CSE, Girijananda Choudhury University, Assam<br />Member</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>Mr. R. James</td>
                  <td>Assistant Professor, School of Pharmaceutical Sciences, Girijananda Choudhury University, Assam<br />Member</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>Ms. Asha Das</td>
                  <td>Assistant Professor, School of Pharmaceutical Sciences, Girijananda Choudhury University, Assam<br />Member</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>Ms. Shreoshree Roy Choudhury</td>
                  <td>Senior Associate, Infosys Ltd, Pune<br />Member</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>Mr. Chandan Sah</td>
                  <td>Senior Associate,<br />C-Quest Capital Brightspark Energy Pvt Ltd, Guwahati, Assam, India<br />Member</td>
                </tr>
                <tr>
                  <td>17</td>
                  <td>Mr. Saikat Banerjee</td>
                  <td>Senior Executive- Commercial Refrigeration Department<br />Blue Star Limited, Guwahati Branch<br />Member</td>
                </tr>
                <tr>
                  <td>18</td>
                  <td>Mr. Bharat Kalita</td>
                  <td>Bharat Fire and Company & Shiv Construction, Hatigaon, Guwahati<br />Member</td>
                </tr>
                <tr>
                  <td>19</td>
                  <td>Mr. Pranjit Sharma</td>
                  <td>Flipkart, Human Resources, Chokigate, Changsari<br />Member</td>
                </tr>
                <tr>
                  <td>20</td>
                  <td>Mr. Muminuz Zaman</td>
                  <td>Director, Rongali Green Energy Pvt. Ltd., Azara<br />Member</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssociationMembers;